import React, {Component} from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Background from "../assets/img/bg2.png"
import Vehicles from "../assets/icons/vehicles.svg"
import HomeFurnitureAppliances from "../assets/icons/homefurnitureandappliances.svg"
import PhonesAndTablets from "../assets/icons/phonesandtablets.svg"
import Property from "../assets/icons/property.svg"
import Electronics from "../assets/icons/electronics.svg"


class Hero extends Component {
	constructor () {
		super()
		this.state = {}
	}
	render () {

		const heroBg = {
			backgroundImage: `url(${Background})`
		}
		return (
			<div className="heroBg" style={heroBg}>

				<Container fluid className="padding5">

					  <Row className=".justify-content-md-center">
					  	<Col md="12" className="heroLeadText"><span className="purple">Buy</span> & <span className="yellow">Sell</span> items <br /> with no rules. Yes, it's that cool!</Col>
					  	<Col md="12" className="heroBodyText">Over 50,000 brand new and used items for sale. Negotiate and buy <br /> items on the go.</Col>
					  	<Col md="12">
					  	<div style={{height: "24px"}}></div>
					  		<Row>
					  			<Col xs="4" md="2" className="categoryCard"><img src={Vehicles} alt="vehicle icon" /> <div style={{height: "10px"}}></div>Vehicles</Col>
					  			<Col xs="4" md="2" className="categoryCard"><img src={Electronics}  alt="eletronics icon" /> <div style={{height: "10px"}}></div>Electronics</Col>
					  			<Col xs="4" md="2" className="categoryCard"><img src={PhonesAndTablets}  alt="phone icon" /> <div style={{height: "10px"}}></div>Phones & Tablets</Col>
					  			<Col xs="4" md="2" className="categoryCard"><img src={Property}  alt="property icon" /> <div style={{height: "10px"}}></div>Property</Col>
					  			<Col xs="4" md="2" className="categoryCard"><img src={HomeFurnitureAppliances}  alt="home&funiture icon" /> <div style={{height: "10px"}}></div>Home & Appliances</Col>
					  		</Row>
					  	</Col>
					  	<Col md="12" className="searchInputCol">
					  		<input className="searchInput" type="text" placeholder="Search for item, category, location…" />
					  	</Col>
					  </Row>

					</Container>
			</div>
		)
	}
}

export default Hero